/**
 * 거래량 표기. (2026-09-10)
 *
 * 🔴 왜 lib/format.ts 가 아닌가
 *   lib 은 공유 영역이라 단독 세션에서만 고칠 수 있고(CLAUDE.md 4.1),
 *   거래량 표기는 지금 단타 화면에서만 쓴다. 가계부·혜택이 쓰게 되면
 *   그때 lib 으로 옮긴다.
 *
 * 🔴 왜 축약하나
 *   표의 가격 칸이 96px(sm 에서 112px)이다. 23,314,005 는 열 자리라
 *   그대로 넣으면 칸을 밀어내고, 좁은 폰에서는 종목명까지 접힌다.
 *   한국 주식 거래량은 만~억 단위라 그 자리에서 끊는 것이 자연스럽다.
 */

/**
 * 거래량을 만·억 단위로 줄인다.
 *
 *   123,456,789 → 1.2억
 *    23,314,005 → 2,331만
 *         5,120 → 5,120
 *
 * 🔴 반올림해서 0이 되는 값은 그대로 적는다
 *   9,800 을 "1만" 으로 올리면 실제보다 커 보인다. 만 미만은 축약하지 않는다.
 */
export function formatVolume(volume: number): string {
  if (volume >= 100_000_000) {
    return `${(volume / 100_000_000).toFixed(1)}억`;
  }
  if (volume >= 10_000) {
    return `${Math.round(volume / 10_000).toLocaleString('ko-KR')}만`;
  }
  return volume.toLocaleString('ko-KR');
}
